import { getUserInfo } from '@/service';
import Cookies from 'js-cookie';

export const setCorpId = (corp) => {
  let domainVal = '';
  if (location.hostname.indexOf('.com') >= 0) {
    domainVal = `.${location.hostname.split('.').slice(-2).join('.')}`;
  } else {
    domainVal = location.hostname;
  }
  // Cookies.set(`appCorpId@-2`, corp.corpId, { expires: 100000 });
  Cookies.set(`appCorpId@-2`, corp.corpId, { domain: domainVal, expires: 100000 });
  corp.applicationList.forEach((item) => {
    // Cookies.set(`appCorpId@${item.appId}`, corp.corpId, { expires: 100000 });
    Cookies.set(`appCorpId@${item.appId}`, corp.corpId, { domain: domainVal, expires: 100000 });
  });
};

export const getCorpId = () => {
  try {
    return Cookies.get(`appCorpId@-2`);
  } catch (e) {
    console.error(e);
    return '';
  }
};

export default {
  getCorpId: getCorpId(),
  namespaced: true,
  state: {
    user: {},
    userAuth: {},
    applicationList: null,
    corporationList: [],
    currentCorp: { corpName: '未绑定企业' },
  },
  mutations: {
    setUser(state, value) {
      state.user = value;
    },
    setUserAuth(state, value) {
      state.userAuth = value;
    },
    setApplicationList(state, value) {
      state.applicationList = value;
    },
    setCorporationList(state, value) {
      state.corporationList = value;
    },
    setCurrentCorp(state, value) {
      state.currentCorp = value;
    },
  },
  actions: {
    async init({ commit }) {
      return getUserInfo().then(({ data: { user, userAuth, corporationList } }) => {
        commit('setUser', user || {});
        commit('setUserAuth', userAuth || {});
        commit('setCorporationList', corporationList || []);
        const corpId = getCorpId();
        if (corporationList.length !== 0) {
          let currentCorp = corporationList.find((item) => item.corpId === parseInt(corpId));
          if (!currentCorp) {
            currentCorp = corporationList.find((item) => item.primaryCorp);
            if (!currentCorp) {
              currentCorp = corporationList[0];
            }
          }
          setCorpId(currentCorp);
          commit('setCurrentCorp', currentCorp);
          commit('setApplicationList', currentCorp.applicationList);
        } else {
          commit('setCurrentCorp', { corpName: '未绑定企业' });
          commit('setApplicationList', []);
        }
      });
    },
    async setCurrentCorpAndAppList({ commit }, corp) {
      setCorpId(corp);
      commit('setCurrentCorp', corp || {});
      commit('setApplicationList', corp.applicationList || []);
    },
  },
  getters: {
    user(state) {
      return state.user;
    },
    userAuth(state) {
      return state.menuData;
    },
    applicationList(state) {
      return state.applicationList;
    },
    corporationList(state) {
      return state.corporationList;
    },
    currentCorp(state) {
      return state.currentCorp;
    },
  },
};
